import { useCallback } from 'react'

import { notificationDanger } from '../../components/ui/Notification/Notification'
import {
  useLoginWithImpersonationTokenMutation,
  useLoginWithMagicTokenMutation,
  useLoginWithSsoMutation,
} from '../../views/Login/operations.generated'

import { setAuthenticationCookie } from './authentication.helpers'

type UseAuthenticationMethodParams = {
  setIsAuthenticated: (isConnected: boolean) => void
  toggleIsLoading: () => void
}

export const useAuthenticationMethod = ({ setIsAuthenticated, toggleIsLoading }: UseAuthenticationMethodParams) => {
  const handleSuccessfullConnection = (response: { token: string; tokenExpiresAt: Date }) => {
    const queryParams = new URLSearchParams(window.location.search)
    const currentUrl = new URL(window.location.href)
    queryParams.forEach((_, param) => {
      queryParams.delete(param)
    })
    const newParams = queryParams.size > 0 ? `?${queryParams.toString()}` : ''
    window.history.replaceState({}, '', `${currentUrl.pathname}${newParams}`)
    setAuthenticationCookie(response)
    setIsAuthenticated(true)
    toggleIsLoading()
  }

  const [loginWithImpersonateToken] = useLoginWithImpersonationTokenMutation()
  const connectWithImpersonateToken = useCallback(async (impersonationToken: string) => {
    await loginWithImpersonateToken({
      variables: { impersonationToken },
      onCompleted: async ({ loginWithImpersonationToken }) => {
        handleSuccessfullConnection(loginWithImpersonationToken)
      },
      onError: (error) => notificationDanger(error.message),
    })
  }, [])

  const [loginWithMagicToken] = useLoginWithMagicTokenMutation()
  const connectWithMagicToken = useCallback(async (magicToken: string) => {
    await loginWithMagicToken({
      variables: { magicToken },
      onCompleted: async ({ loginWithMagicToken }) => {
        handleSuccessfullConnection(loginWithMagicToken)
      },
      onError: (error) => notificationDanger(error.message),
    })
  }, [])

  const [loginWithSSO] = useLoginWithSsoMutation()
  const connectWithPaypal = useCallback(async (paypalSsoToken: string) => {
    loginWithSSO({
      variables: { idToken: paypalSsoToken },
      onCompleted: async ({ loginWithSso }) => {
        handleSuccessfullConnection(loginWithSso)
      },
      onError: (error) => notificationDanger(error.message),
    })
  }, [])

  return {
    connectWithImpersonateToken,
    connectWithMagicToken,
    connectWithPaypal,
  }
}
